// assets
import DashboardOutlined from '@ant-design/icons/DashboardOutlined';
import FileOutlined from '@ant-design/icons/FileOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import OrderedListOutlined from '@ant-design/icons/OrderedListOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import FormOutlined from '@ant-design/icons/FormOutlined';
import ApartmentOutlined from '@ant-design/icons/ApartmentOutlined';
import AppstoreOutlined from '@ant-design/icons/AppstoreOutlined';
import BookOutlined from '@ant-design/icons/BookOutlined';
import PictureOutlined from '@ant-design/icons/PictureOutlined';

// icons
const icons = {
  DashboardOutlined,
  FileOutlined,
  FileTextOutlined,
  OrderedListOutlined,
  TeamOutlined,
  SettingOutlined,
  FormOutlined,
  ApartmentOutlined,
  AppstoreOutlined,
  BookOutlined,
  PictureOutlined
};

// ==============================|| MENU ITEMS - ADMIN ||============================== //

// `catalogueCode` ties an item to its Features and Pages feature (rbac_app_feature.code),
// matched by CODE so switching that feature off in the admin catalogue hides it here
// regardless of route data. See menu-items/catalogueVisibility.js.
const admin = {
  id: 'group-admin',
  title: 'Admin',
  icon: icons.DashboardOutlined,
  type: 'group',
  children: [
    {
      id: 'admin-dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/admin/dashboard',
      icon: icons.DashboardOutlined,
      breadcrumbs: false,
      catalogueCode: 'dashboard_reports'
    },
    {
      id: 'admin-form-builder',
      title: 'Forms Library',
      type: 'item',
      url: '/admin/form-builder',
      icon: icons.FormOutlined,
      breadcrumbs: false,
      desktopOnly: true,
      catalogueCode: 'forms_library'
    },
    {
      id: 'admin-workflow-builder',
      title: 'Workflow',
      type: 'item',
      url: '/admin/workflow-builder',
      icon: icons.ApartmentOutlined,
      breadcrumbs: false,
      desktopOnly: true,
      catalogueCode: 'workflow'
    },
    {
      id: 'admin-components',
      title: 'Components',
      type: 'item',
      url: '/admin/components',
      icon: icons.AppstoreOutlined,
      breadcrumbs: false,
      catalogueCode: 'components'
    },
    {
      id: 'admin-skills',
      title: 'Skills Repository',
      type: 'item',
      url: '/admin/skills',
      icon: icons.BookOutlined,
      breadcrumbs: false,
      catalogueCode: 'skill_repository'
    },
    {
      id: 'admin-materials',
      title: 'Material Repository',
      type: 'item',
      url: '/admin/materials',
      icon: icons.PictureOutlined,
      breadcrumbs: false,
      catalogueCode: 'material_repository'
    },
    {
      id: 'admin-pages',
      title: 'Pages',
      type: 'collapse',
      icon: icons.FileOutlined,
      children: [
        {
          id: 'admin-pages-select-center',
          title: 'Select Center',
          type: 'item',
          url: '/admin/pages/select-center',
          breadcrumbs: false
        },
        {
          id: 'admin-pages-select-program',
          title: 'Select Program',
          type: 'item',
          url: '/admin/pages/select-program',
          breadcrumbs: false
        },
        {
          id: 'admin-pages-select-grade',
          title: 'Select Grade',
          type: 'item',
          url: '/admin/pages/select-grade',
          breadcrumbs: false
        },
        {
          id: 'admin-pages-coming-soon',
          title: 'Coming Soon',
          type: 'item',
          url: '/admin/pages/coming-soon',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'admin-user-management',
      title: 'User Management',
      type: 'item',
      url: '/admin/user-management',
      icon: icons.TeamOutlined,
      breadcrumbs: false,
      catalogueCode: 'user_management'
    },
    {
      id: 'admin-settings',
      title: 'Settings',
      type: 'item',
      url: '/admin/settings',
      icon: icons.SettingOutlined,
      breadcrumbs: false,
      disabled: true
    }
  ]
};

export default admin;
